import { CollectionService } from './index';

const UserService = CollectionService('admin-tool-users');

export default UserService;
